import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GenericCrudService } from './generic-crud.service';
const API_URL = environment.prismaApiUrl +'/api/dispo/base-text-presets';

@Injectable({
    providedIn: 'root'
})
export class BaseTextPresetService extends GenericCrudService<Product>{

    constructor(http: HttpClient) {
        super(http, 'api/dispo/base-text-presets');
    }

    exportTextPreset(id: any): Observable<any> {
        return this.http.get(API_URL + '/export-text-preset/' + id, { responseType: 'blob' });
    }

    importTextPreset(file: File) {
        const formData = new FormData();
        formData.append('file', file);
    
        return this.http.post(API_URL + '/import-text-preset', formData);
      }
}

export interface Product {
    id: number;
    name: string;
    price: number;
    // Weitere Eigenschaften deines Produkts
}

